// ProfilePage.js
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import '../src/profilepagestyle.css';
import { useHistory } from 'react-router-dom';

import { toast , ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BaseAPI from './api/apiurl';




const ProfilePage = () => {
 
  const [password, setPassword] = useState(null);
  const [userid, setUserId] = useState(null);

  const handelcancel = () => {
    history.push('/timeinlive/dashboard');
  }

  const UsaerName = localStorage.getItem('username');
  const RoleName = localStorage.getItem('role');
  const CustomerName = localStorage.getItem('customername');
  const ps = localStorage.getItem('password');

  const displayRole = (role) => {
    switch (role) {
      case 'A':
        return 'Admin';
      case 'U':
        return 'User';
      default:
        return 'Unknown Role';
    }
  };
  
  const history = useHistory();

  return (
    <Container>
     
      <Row className="justify-content-center mt-5">
        <Col md={6}>
          <div className="profile-card">
            <h2 className="text-center mb-4">Edit Profile</h2>
            <Form>
          
                <div>
              <Form.Group controlId="customerName">
                <Form.Label>Customer Name</Form.Label>
                <Form.Control type="text" placeholder="Enter customer name" defaultValue={CustomerName} disabled/>
              </Form.Group>
              &nbsp; &nbsp;
              <Form.Group controlId="role">
                <Form.Label>Role</Form.Label>
                <Form.Control type="text" placeholder="Enter role" defaultValue={displayRole(RoleName)} disabled/>
              </Form.Group>
              &nbsp; &nbsp;
              <Form.Group controlId="username">
                <Form.Label>Username</Form.Label>
                <Form.Control type="text" placeholder="Enter username" defaultValue={UsaerName} disabled/>
              </Form.Group>
              &nbsp; &nbsp;
              <Form.Group controlId="password">
                <Form.Label>Password (only change password)</Form.Label>
                <Form.Control type="text" placeholder={UsaerName} value={ps} onChange={(e) => setPassword(e.target.value)} disabled/>
                &nbsp; &nbsp; &nbsp; 
              </Form.Group>
             &nbsp; &nbsp;
             <div  className="d-flex justify-content-center">
              {/* <Button variant="primary" type="submit" className="btn btn-primary">
                Change
              </Button>  &nbsp; &nbsp; */}
              <Button variant="primary" className="btn btn-primary" onClick={handelcancel}>
                Go Back
              </Button>
              </div>
              </div>
            </Form>
          </div>
        </Col>
      </Row>
      <ToastContainer />
      <br></br><br></br><br></br>
    </Container>
    
    
  );
};

export default ProfilePage;
